import { render, staticRenderFns } from "./about.vue?vue&type=template&id=0e396ed0&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style0 from "./about.scss?vue&type=style&index=0&id=0e396ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e396ed0",
  null
  
)

export default component.exports